import React from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Table
} from "reactstrap";
import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, pagination } from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";



toast.configure();

const ReadOnly = ({  showModal,setShowModel,editDocument }) => {


  return (
    <>
      <Modal isOpen={showModal}
        backdrop="static">
        <ModalHeader>
        </ModalHeader>
        <ModalBody>
          <label>
           Another user is currently editing this file.This file is read-only.Do you want to continue?
          </label>
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={()=>editDocument()} className="cancel-btn">
            Enter File
          </Button>
          <Button color="secondary" onClick={()=>setShowModel()} >
            Close
          </Button>
        </ModalFooter>

      </Modal>
    </>
  );
};

export default ReadOnly;
